import * as motion from "motion/react-client";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { realtimeSelected, realtimeSelectedCamera } from "slice/realtimeSlice";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import { createMediaMTXWebRTCReader } from "Config/migrasiReader";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { LoadingLive } from "Component/LoadingModal/LoadingLive";
import { Typography } from "@mui/material";
import {
  initializeStream,
  setErrorState,
  setLoadingState,
} from "slice/checkMediaMTXSlice";
import { subscribeMessage, unsubscribeCurrent } from "Config/natsClient";
import { getTarget } from "slice/targetSlice";
import { getTargetIsDpo } from "slice/targetIsDpoSlice";

export const Videos = (props) => {
  const dispatch = useDispatch();
  const hasRetriedRef = useRef(false);
  const { dataIpCamList, isLoadingIpCamList } = props;
  const loadingState = useSelector(
    (state) => state.checkMediaMTX.loadingStates
  );
  const { isConnected, isError, errorMessage, isSubscribed } = useSelector(
    (state) => state.statusNats
  );
  const errorState = useSelector((state) => state.checkMediaMTX.errorStates);
  const [loadingStates, setLoadingStates] = useState(loadingState);
  const [errorStates, setErrorStates] = useState(errorState);
  const [query, setQuery] = useState(window.location.search);
  // console.log(loadingStates, "loadingStates");

  const handleSeclectedCamera = (video) => {
    localStorage.setItem("subs", video?.id);
    dispatch(realtimeSelectedCamera(video));
    dispatch(realtimeSelected(video));
  };
  const checkVideos = (camera) => {
    dispatch(initializeStream(camera));
    // setLoadingStates((prev) => ({ ...prev, [camera]: true }));
  };

  useEffect(() => {
    const handleURLChange = () => setQuery(window.location.search);
    window.addEventListener("popstate", handleURLChange);
    return () => window.removeEventListener("popstate", handleURLChange);
  }, []);

  useEffect(() => {
    setLoadingStates(loadingState);
  }, [loadingState]);

  useEffect(() => {
    setErrorStates(errorState);
  }, [errorState]);

  useEffect(() => {
    dispatch(setLoadingState(loadingStates));
  }, [loadingStates]);

  useEffect(() => {
    dispatch(setErrorState(errorStates));
  }, [errorStates]);

  const [detectedCameras, setDetectedCameras] = useState(new Set());

  // useEffect(() => {
  //   const callback = async (data) => {

  //     try {
  //       if (data.device_uuids) {
  //         setDetectedCameras(new Set(data.device_uuids)); // Simpan ID kamera yang terdeteksi
  //       }
  //     } catch (error) {
  //       console.error("Error processing data:", error);
  //     }
  //   };

  //   const unsubscribe = subscribeMessage("detected", callback);

  //   return () => {
  //     if (typeof unsubscribe === "function") {
  //       unsubscribe();
  //     }
  //   };
  // }, []);

  useEffect(() => {
    if (isError && !hasRetriedRef.current) {
      // console.log("kepanggil 1");
      checkVideos();
      hasRetriedRef.current = true;
    }
  }, [isError]);

  useEffect(() => {
    unsubscribeCurrent();
    dispatch(getTarget([]));
    dispatch(getTargetIsDpo([]));
  }, []);

  if (isLoadingIpCamList) {
    return (
      <div className="w-full overflow-hidden">
        {isLoadingIpCamList && <LoadingLive />}
      </div>
    );
  }
// console.log(dataIpCamList, 'dataIpCamList')
  return (
    <div
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2  text-white overflow-scroll "
      style={{ maxHeight: "80vh" }}
    >
      {dataIpCamList?.map((video, index) => {
        // console.log(loadingStates[video?.ip_address], "video?.ip_address");
        return (
          <motion.div
            key={video.id}
            initial={{ opacity: 0, y: 100 }} // Muncul dari bawah
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: (index % 3) * 0.1 }}
            className="relative bg-black cursor-pointer hover:bg-slate-700"
            onClick={() => {
              if (!errorStates[video?.ip_address]) {
                handleSeclectedCamera(video);
              } else {
                checkVideos(video?.ip_address);
              }
              // dispatch(cleardataIpCamList([]));
            }}
          >
            <div
              className="absolute inset-0 pointer-events-none border"
              // className={`absolute inset-0 pointer-events-none  ${
              //   detectedCameras.has(video.id) ? "bg-red-600" : ""
              // }`}
            >
              <div className="absolute top-0 z-10 w-full border-t-2 border-mo-button"></div>
              <div className="absolute bottom-0 z-10 w-full border-b-2 border-mo-button"></div>
              <div className="absolute left-0 z-10 h-full border-l-2 border-mo-button"></div>
              <div className="absolute right-0 z-10 h-full border-r-2 border-mo-button"></div>
            </div>
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute top-0 left-0 z-20 w-4 h-4 border-t-4 border-l-4 border-mo-text"></div>
              <div className="absolute top-0 right-0 z-20 w-4 h-4 border-t-4 border-r-4 border-mo-text"></div>
              <div className="absolute bottom-0 left-0 z-20 w-4 h-4 border-b-4 border-l-4 border-mo-text"></div>
              <div className="absolute bottom-0 right-0 z-20 w-4 h-4 border-b-4 border-r-4 border-mo-text"></div>
            </div>
            <div className="flex flex-col p-4 gap-4 h-[300px]">
              <div className="flex justify-between mb-2">
                <div className="flex items-center gap-2">
                  <img
                    src={
                      loadingStates[video?.ip_address]
                        ? "/asset/EllipseYellow.svg" // Loading
                        : errorStates[video?.ip_address]
                          ? "/asset/Ellipse.svg" // Error
                          : "/asset/EllipseGreen.svg" // Success
                    }
                    width={20}
                    alt="Status Icon"
                  />
                  <div>
                    {video?.device_name?.length > 20
                      ? video.device_name.slice(0, 35) + "..."
                      : video?.device_name}
                  </div>
                </div>
                <div className="flex gap-2">
                  {loadingStates[video?.ip_address] ? (
                    <img
                      className=""
                      src="/asset/loadBall.gif"
                      width={20}
                      // height={10}
                      alt="Live Icon"
                    />
                  ) : errorStates[video?.ip_address] ? (
                    <VideocamOffIcon color="error" />
                  ) : (
                    <img src="/asset/live.svg" width={80} alt="Live Icon" /> // Jika sukses, tampilkan ikon "live"
                  )}
                </div>
              </div>

              {/* Video Section */}
              <div className="flex flex-col items-center justify-center grow relative">
                {video.ip_address !== "" ? (
                  <div className="relative w-full h-full">
                    <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-70 text-white">
                      {/* {!errorStates[video?.ip_address]  ? ( */}
                      {!errorStates[video?.ip_address] &&
                      !loadingStates[video?.ip_address] ? (
                        <iframe
                          src={video?.ip_address}
                          className="absolute w-full h-full"
                          style={{
                            border: "none",
                            objectFit: "cover",
                            // pointerEvents: 'none'
                          }}
                          allow="autoplay; encrypted-media"
                          allowFullScreen
                        />
                      ) : (
                        <div className="absolute flex flex-col items-center justify-center">
                          <h1 className="font-bold text-xs md:text-base lg:text-lg text-white mb-6 text-center">
                            {loadingStates[video?.ip_address] ? (
                              <img
                                className=""
                                src="/asset/loadBall.gif"
                                width={50}
                                // height={10}
                                alt="Live Icon"
                              />
                            ) : errorStates[video?.ip_address] ? (
                              <div className="w-full h-full flex flex-col justify-center items-center">
                                <img
                                  src="/asset/fluent_plug-disconnected.svg"
                                  alt="Disconnected"
                                  className="mb-4 w-10 h-10"
                                />
                                <div className="">
                                  Koneksi Kamera Bermasalah
                                </div>
                                <Typography
                                  variant="caption"
                                  gutterBottom
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }} // Menyusun secara horizontal
                                >
                                  <RestartAltIcon sx={{ fontSize: 16 }} />
                                  Klik untuk memuat ulang
                                </Typography>
                              </div>
                            ) : (
                              <>
                                <div>Menghubungkan</div>
                              </>
                            )}
                          </h1>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col items-center justify-center w-full h-full bg-stone-200 text-black">
                    <div className="font-semibold">No cam selected.</div>
                    <p className="font-light mt-2 text-sm">
                      Select camera to start monitoring.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};
